module.exports = __webpack_public_path__ + "static/media/294168.fb019563.png";